<template>
  <a-modal width="55%" :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
    :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
    <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
      <!--可编辑区域 start-->
      <div class="hidden">
        <a-form-item label="id" name="id">
          <a-input v-model:value="form.id" />
        </a-form-item>
      </div>
      <a-row :gutter="[24, 8]">
        <a-col :span="12">
          <a-form-item label="职位" name="jobTitle">
            <DictSelect v-model:value="form.jobTitle" :dict-name="education.HOPE_JOB" placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="行业类型" name="industry">
            <DictSelect v-model:value="form.industry" :dict-name="education.RESEARCH_FIELD" placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="类型" name="natureWork">
            <DictSelect v-model:value="form.natureWork" :dict-name="education.WORK_TYPE" placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="学历" name="educationBackground">
            <DictSelect v-model:value="form.educationBackground" :dict-name="education.EDUCATION_BACKGROUND"
              placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="工作城市" name="prov">
            <city-select-all v-model:prov="form.prov" v-model:city="form.city" v-model:dist="form.dist"
              placeholder="请选择省/市/区" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="详细地址" name="fullAddress">
            <a-input v-model:value="form.fullAddress" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="薪资" name="salary">
            <DictSelect v-model:value="form.salary" :dict-name="education.SALARY" placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="工作经验" name="workExperience">
            <DictSelect v-model:value="form.workExperience" :dict-name="education.WORK_EXPERIENCE" placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="福利待遇" name="welfareTreatment">
            <DictSelect :multiple="true" v-model:value="form.welfareTreatment" :dict-name="education.FRINGE_BENEFITS"
              placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="联系人姓名" name="contactName">
            <a-input v-model:value="form.contactName" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="联系人电话" name="contactNumber">
            <a-input v-model:value="form.contactNumber" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="招聘人数" name="numberRecruits">
            <a-inputNumber style="width: 100%" v-model:value="form.numberRecruits" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="期望入职时间" name="expectedTimeEntry">
            <DatePicker style="width: 100%" v-model:value="form.expectedTimeEntry" :format="dateFormat.DATE_DAY"
              :showTime="false" />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="岗位职责" name="jobResponsibility">
            <a-textarea v-model:value="form.jobResponsibility" placeholder="请输入"
              :auto-size="{ minRows: 4, maxRows: 6 }" />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="任职要求" name="jobRequirements">
            <a-textarea v-model:value="form.jobRequirements" placeholder="请输入" :auto-size="{ minRows: 4, maxRows: 6 }" />
          </a-form-item>
        </a-col>
      </a-row>
      <!--可编辑区域 end-->
    </a-form>
  </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { formMixin } from "@/mixins";
import { enterpriseRrecruitmentInfo } from "@/api/educationService";
import DictSelect from "@/components/other/DictSelect";
import CitySelectAll from "@/components/form/select/AllCitySelect";
import DatePicker from "@/components/form/datePicker/DatePicker";
import { education, dateFormat } from "@/config/variableConfig";

export default {
  name: "UserModal",
  components: { DictSelect, DatePicker, CitySelectAll },
  mixins: [formMixin],
  data() {
    return {
      education,
      dateFormat,
      form: {
        id: null,
        jobTitle: null,
        industry: null,
        natureWork: null,
        educationBackground: null,
        prov: null,
        city: null,
        dist: null,
        fullAddress: null,
        salary: null,
        workExperience: null,
        contactName: null,
        contactNumber: null,
        numberRecruits: null,
        expectedTimeEntry: null,
        jobResponsibility: null,
        jobRequirements: null,
      },
      rules: {
        jobTitle: [dataCheck.required({})],
        industry: [dataCheck.required({})],
        natureWork: [dataCheck.required({})],
        educationBackground: [dataCheck.required({})],
        prov: [dataCheck.required({})],
        city: [dataCheck.required({})],
        dist: [dataCheck.required({})],
        fullAddress: [dataCheck.required({})],
        salary: [dataCheck.required({})],
        workExperience: [dataCheck.required({})],
        welfareTreatment: [],
        contactName: [dataCheck.required({})],
        contactNumber: [dataCheck.required({})],
        numberRecruits: [dataCheck.required({ type: 'number' })],
        expectedTimeEntry: [dataCheck.required({})],
        jobResponsibility: [dataCheck.required({})],
        jobRequirements: [dataCheck.required({})],
        id: [],
      },
    }
  },
  computed: {
    submitUrl() {
      return this.form.id ? enterpriseRrecruitmentInfo.edit : enterpriseRrecruitmentInfo.add
    }
  },
}
</script>
<style scoped lang="less"></style>
